export function operacoesInRequest(params = {}) {
  return {
    type: '@operacao/OPERACOES_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacao(idoperacao) {
  return {
    type: '@operacao/FIND_OPERACAO',
    payload: { idoperacao },
  };
}

export function failedRequest() {
  return {
    type: '@operacao/FAILED_REQUEST',
  };
}

export function deleteOperacao(idoperacao, params) {
  return {
    type: '@operacao/DELETE_OPERACAO',
    payload: { idoperacao, params },
  };
}

export function updateOperacao(operacao, params) {
  return {
    type: '@operacao/UPDATE_OPERACAO',
    payload: { operacao, params },
  };
}

export function storeOperacao(operacao, params) {
  return {
    type: '@operacao/STORE_OPERACAO',
    payload: { operacao, params },
  };
}

export function successInRequest(
  operacoes,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacao/SUCCESS_IN_REQUEST',
    payload: { operacoes, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacao) {
  return {
    type: '@operacao/SUCCESS_REQUEST',
    payload: { operacao },
  };
}

export function successRemove(params) {
  return {
    type: '@operacao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacao/RECORD_FILTERING',
    payload: { params },
  };
}
